import React from 'react';

const ReviewCard = ({ review }) => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span
        key={index}
        className={`text-lg ${
          index < rating ? 'text-yellow-400' : 'text-gray-300'
        }`}
      >
        ★
      </span>
    ));
  };

  return (
    <div className="bg-amber-50 rounded-lg p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
      <div className="flex items-center gap-1 mb-3">
        {renderStars(review.rating)}
      </div>
      <h4 className="font-semibold text-gray-800 mb-2 text-sm sm:text-base">
        {review.name}
      </h4>
      <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
        {review.text}
      </p>
    </div>
  );
};

export default ReviewCard;

